<template lang="html">
  <picture id="picture-tag">
    <source v-for="size in sizeConfig"
            v-if="imageName"
            :media="`(min-width: ${size.minWidth}px)`"
            :srcset="getImageSrcset(size.maxWidth)">
    <img :src="imageFallbackSrc.classic" :srcset="`${imageFallbackSrc.retina} 2x`" alt="Csepel photo">
  </picture>
</template>

<script>
export default {
  name: 'imageContainer',
  props: ['imageName', 'width', 'height'],
  mounted () {
    let img = this.$el.querySelector('img')
    img.style.width = this.width
    img.style.height = this.height
  },
  data: function () {
    return {
      imageFolder: 'csepel/fotos',
      fallBackImageSize: 2000,
      sizeConfig: [
        {
          minWidth: 1200,
          maxWidth: 3600
        },
        {
          minWidth: 992,
          maxWidth: 2400
        },
        {
          minWidth: 569,
          maxWidth: 1900
        },
        {
          minWidth: 256,
          maxWidth: 1100
        }
      ]
    }
  },
  methods: {
    getImageSrcset(width) {
      let urls = this.$store.getters['config/getImageUrls']({name:this.imageName, width:width, folder:this.imageFolder})
      return `${urls.classic}, ${urls.retina} 2x`
    }
  },
  computed: {
    imageFallbackSrc() {
      return this.$store.getters['config/getImageUrls']({name: this.imageName, width:this.fallBackImageSize, folder:this.imageFolder})
    }
  }
}
</script>

<style scoped>
#picture-tag, img {
  object-fit: cover;
}
</style>
